import {
  CommandButton,
  VerticalDivider,
  Text,
  ProgressIndicator,
} from "@fluentui/react";
import { SharedActionBarWithLoading } from "components/shared/SharedActionBar";
import icons from "components/shared/Icons";
import useRouter from "hooks/useRouter";
import customTheme from "helpers/customTheme";
import { 
  AgreementObjectType,
  AgreementObjectEditState,
} from "models/agreements";
import { usePolicyEditStructureNodeManager } from "./structure/PolicyEditStructureNodeManager";
import { IPolicyInfo } from "./types";

// Loading component for SharedActionBar
function PolicyLoadingSubstitute() {
  return <div>Loading...</div>;
}

export type PolicyEditHeaderProps = {
  policyInfo: IPolicyInfo;
  setCurrentRevision?: (revision: any) => void;
  isPolicyEditable?: boolean;
};

function PolicyEditHeader({
  policyInfo,
  setCurrentRevision,
  isPolicyEditable = true,
}: PolicyEditHeaderProps) {
  const { back } = useRouter();
  const { nodeTree } = usePolicyEditStructureNodeManager();
  
  // Disable publish button until templates are added AND have criteria
  const hasTemplates = Object.keys(nodeTree.nodes).length > 0;
  const hasTemplatesWithCriteria = hasTemplates && 
    Object.values(nodeTree.nodes).some(node => 
      node.content?.constraints && node.content.constraints.length > 0
    );
  const isPublishable = hasTemplatesWithCriteria;

  return (
    <>
      <div style={customTheme.editTemplateHeading}>
        <CommandButton
          data-automation-id="policy-back-button"
          style={{ height: "100%", marginRight: 10, marginLeft: 10 }}
          iconProps={icons.back}
          ariaDescription="Policy edit back button"
          onClick={back}
        />
        <VerticalDivider />
        <Text
          data-automation-id="policyname"
          style={{ margin: "0px 20px", fontWeight: 500 }}
          variant="mediumPlus"
        >
          {policyInfo.name}
        </Text>
        <SharedActionBarWithLoading
          isLoading={policyInfo.isLoading || false}
          LoadingSubstitute={PolicyLoadingSubstitute}
          objectType={AgreementObjectType.policy}
          objectInfo={{
            policy: {
              id: policyInfo.id,
              name: policyInfo.name,
              description: policyInfo.description,
              type: policyInfo.type,
              status: policyInfo.status,
              etag: "draft-etag",
              templateId: policyInfo.templateId,
              isTestPolicy: policyInfo.isTestPolicy,
              agreementEffectiveDate: policyInfo.agreementEffectiveDate,
              criteria: policyInfo.criteria,
            },
            hasData: policyInfo.hasData,
            isLoading: policyInfo.isLoading || false,
          }}
          openEditPanel={() => {
            // TODO: Implement policy edit panel opening
          }}
          setCurrentRevision={setCurrentRevision || (() => {})}
          editState={AgreementObjectEditState.NewTemplate}
          disablePublishOverride={!isPublishable}
          componentInfo="policyEdit"
          additionalStyles={{
            versionMenuStyles: { 
              height: 48, 
              border: "none",
              pointerEvents: "none", // Disable dropdown interaction
            },
            actionBarStyles: { root: { flexGrow: 2 } },
          }}
        />
        {/* <SharedActionBarWithLoading
          isLoading={policyInfo.isLoading || false}
          LoadingSubstitute={PolicyLoadingSubstitute}
          objectType={AgreementObjectType.template} // TODO: Add AgreementObjectType.policy
          objectInfo={{
            ...policyInfo,
            contents: hasTemplates ? [{
              id: "policy-templates",
              title: "Policy Templates",
              type: "templates"
            }] : [], // Empty array when no templates
            revisions: [{ 
              id: "draft", 
              status: "Draft", 
              number: undefined, // No version number
              etag: "draft-etag" 
            }],
            currentRevision: { 
              id: "draft", 
              status: "Draft", 
              number: undefined, // No version number
              etag: "draft-etag" 
            }
          }}
          openEditPanel={() => {
            // TODO: Implement policy edit panel opening
          }}
          setCurrentRevision={setCurrentRevision || (() => {})}
          editState={AgreementObjectEditState.NewTemplate}
          disablePublishOverride={!isPublishable}
          additionalStyles={{
            versionMenuStyles: { 
              height: 48, 
              border: "none",
              pointerEvents: "none", // Disable dropdown interaction
            },
            actionBarStyles: { root: { flexGrow: 2 } },
          }}
          componentInfo="policyEdit" // Custom identifier to hide Test button
        /> */}
      </div>
      {!isPolicyEditable && (
        <ProgressIndicator
          ariaValueText="Progress Bar"
          styles={{
            itemProgress: {
              padding: 0,
            },
          }}
        />
      )}
    </>
  );
}

export default PolicyEditHeader;